import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./_materialAllocation.scss";

// Reusable shimmer / skeleton blocks for the Materials Assignment module.
// Uses the `.mat-shimmer` class defined in _materialAllocation.scss, matching
// the Finance module's skeleton aesthetic.

export const Shimmer = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="mat-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// Generic table skeleton (header row + body rows).
export const MaterialTableShimmer = ({ rows = 6, cols = 2 }) => {
    const widths = [60, 320];
    const cells = widths.slice(0, cols);
    return (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 20px" }}>
            <div style={{ display: "flex", gap: 16, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                {cells.map((w, i) => <Shimmer key={i} width={w} height={13} style={{ flexShrink: 0 }} />)}
            </div>
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} style={{ display: "flex", gap: 16, padding: "14px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                    {cells.map((w, i) => <Shimmer key={i} width={w} height={12} style={{ flexShrink: 0 }} />)}
                </div>
            ))}
        </div>
    );
};

// Full-page skeleton for the initial load (header + filter row + table) inside the
// Finance-style card shell.
export const MaterialAssignShimmer = () => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                {/* Header */}
                <div style={{ padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9" }}>
                    <Shimmer width={38} height={38} radius={10} style={{ flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                        <Shimmer width={190} height={15} style={{ marginBottom: 8 }} />
                        <Shimmer width={250} height={10} />
                    </div>
                    <div style={{ display: "flex", gap: 10 }}>
                        {[0, 1, 2].map((i) => <Shimmer key={i} width={140} height={40} radius={9} style={{ flexShrink: 0 }} />)}
                    </div>
                </div>
                {/* Filter row */}
                <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6" }}>
                    <Row className="g-2">
                        {[0, 1, 2].map((i) => (
                            <Col xl={3} lg={4} md={6} sm={12} key={i} className="mb-2">
                                <Shimmer width="55%" height={11} style={{ marginBottom: 7 }} />
                                <Shimmer width="100%" height={42} radius={9} />
                            </Col>
                        ))}
                    </Row>
                </div>
                {/* Table */}
                <div style={{ padding: "20px 24px" }}>
                    <MaterialTableShimmer rows={6} cols={2} />
                </div>
            </div>
        </Container>
    </div>
);

export default MaterialAssignShimmer;
